import { ContractValidationError, createPostId, type PostId, type VoteContext } from '../../types/pifster-contracts';

type VoteButtonElement = HTMLButtonElement & {
  dataset: DOMStringMap;
};

export interface VoteDomContextInput {
  readonly charityId: string;
  readonly charityName: string;
  readonly periodId: string;
  readonly periodLabel: string;
  readonly donateHref: string;
}

function toPostId(rawValue: string, fieldName: string): PostId {
  const trimmed = rawValue.trim();
  const parsed = Number.parseInt(trimmed, 10);
  if (!trimmed || Number.isNaN(parsed) || parsed <= 0) {
    throw new ContractValidationError(`Missing or invalid ${fieldName}.`);
  }

  return createPostId(parsed);
}

export function scrapeVoteContext(button: VoteButtonElement): {
  readonly context: VoteContext;
  readonly donateHref: string;
} {
  const charityIdRaw = String(
    button.getAttribute('data-charity-id')
      ?? button.closest('[data-charity-post-id]')?.getAttribute('data-charity-post-id')
      ?? '',
  );
  const periodIdRaw = String(
    button.getAttribute('data-period-id')
      ?? button.closest('[data-period-id]')?.getAttribute('data-period-id')
      ?? '',
  );
  const charityId = toPostId(charityIdRaw, 'charity-id');
  const periodId = toPostId(periodIdRaw, 'period-id');
  const charityName = String(button.getAttribute('data-charity-name') ?? '').trim();
  const periodLabel = String(button.getAttribute('data-period-label') ?? '').trim();

  let donateHref = String(button.getAttribute('href') ?? button.getAttribute('data-donate-url') ?? '').trim();
  if (!donateHref) {
    const card = button.closest('[data-instance-id], .monthly-charity, .pifster-charity-card, [data-charity-post-id]');
    if (card && typeof card.querySelector === 'function') {
      const donateEl = card.querySelector('a.monthly-charity-donate-btn, a.pifster-donate-btn, a[class*="donate"], a[href*="checkout"], a[href*="pabbly"]');
      if (donateEl instanceof HTMLAnchorElement) {
        donateHref = String(donateEl.getAttribute('href') ?? '').trim();
      }
    }
  }

  return {
    context: {
      charityId,
      charityName,
      periodId,
      periodLabel,
    },
    donateHref,
  };
}
